import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import LearningForm from "./forms/addLearningForm";
import Particle from "../Particle";
import VerticalNavBar from "../VerticalNavBar";
import ProjectForm from "./forms/projectAddingForm";
import TestForm from "./forms/addTest";
import ReadingForm from "./forms/paperOrBlogAddingForm";
import CertificationForm from "./forms/certificationForm";
import AddToGraph from "./forms/addToGraph";
import SkillForm from "./forms/skillForm";

function PaperPage(props) {
  props.setLearning(true);
  return (
    <>
      <Container fluid className="resume-section">
        <Particle />
        <Col>
          <Row>
            <SkillForm />
          </Row>
          <Row>
            <VerticalNavBar
              setIsAuthenticated={props.setIsAuthenticated}
              setLearning={props.setLearning}
            />
          </Row>
          <Row>
            <LearningForm />
          </Row>
          <Row>
            <TestForm />
          </Row>
          <Row>
            <AddToGraph />
          </Row>
          <Row>
            <ReadingForm />
          </Row>
          <Row>
            <ProjectForm />
          </Row>
          <Row>
            <CertificationForm />
          </Row>
        </Col>
      </Container>
    </>
  );
}

export default PaperPage;
